import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

import { CardContent } from '../types/card-content';

/** service to pull latest news from rss feed */
@Injectable( {
    providedIn: 'root'
} )
export class NewsService {
    /** ignore in coverage */
    #httpClient = inject( HttpClient );
    #cookieService = inject( CookieService );

    /**
     * get rss feed
     * reduce the incoming feed to a given number of items
     * and provide response as json object
     *
     * @param {string} feed - type of news feed
     * @param {number} count - number of news items to return
     * @returns array of News objects with length of count
     */
    getRSSNews( feed: string, count: number ): Observable<CardContent[]> {
        const lang = this.getFeedLanguage();
        const rssDomain = environment.rssFeeds.domain;
        const rssFeedUrl = `${rssDomain}/${lang}/${feed}/json`;

        return this.#httpClient.jsonp<CardContent[]>( `${rssFeedUrl}`, 'data' ).pipe(
            map( ( data: CardContent[] ) => {
                // create cache news items
                const items = data.slice( 0, count );
                return items;
            } ),
            catchError( ( error ) => {
                console.error( error );
                return of( [] );
            } )
        );
    }

    /**
     * match user language with feeds
     * @returns {string} language code for feed
     */
    getFeedLanguage(): string {
        let lang: string = '';
        const cookieExists: boolean = this.#cookieService.check( 'language' );
        if ( cookieExists ) {
            lang = this.#cookieService.get( 'language' );
        } else {
            lang = navigator.language;
        }

        let feedLang = '';
        switch ( lang.slice( 0, 2 ) ) {
            case 'de':
                feedLang = 'de';
                break;
            // case 'es':
            //     feedLang = 'es';
            //     break;
            // case 'nl':
            //     feedLang = 'nl';
            //     break;
            default:
                feedLang = 'en';
        }

        return feedLang;
    }
}
